const two = (value: number): string => String(value).padStart(2, '0')

/** Время суток локально: `14:05:09`. */
export function clockText(ms: number): string {
  const date = new Date(ms)
  return `${two(date.getHours())}:${two(date.getMinutes())}:${two(date.getSeconds())}`
}

/** Момент из ISO-строки агента или сервера: `21.10 14:05`; нечитаемое остаётся как есть (дословно). */
export function momentText(iso: string): string {
  const ms = Date.parse(iso)
  if (Number.isNaN(ms)) return iso
  const date = new Date(ms)
  return `${two(date.getDate())}.${two(date.getMonth() + 1)} ${two(date.getHours())}:${two(date.getMinutes())}`
}
